"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractComponent_1 = __importDefault(require("./AbstractComponent"));
var fetch_1 = require("../utility/fetch");
var main_1 = require("../main");
var constants_1 = require("../data/constants");
var constantsClasses_1 = require("../data/constantsClasses");
var Filter = /** @class */ (function (_super) {
    __extends(Filter, _super);
    function Filter() {
        var _this = _super.call(this, constants_1.DATA_FILTER) || this;
        _this.CLASS_CHECKBOX_PREFILL = 'checkbox__label--prefill';
        _this.CLASS_RADIO_PREFILL = 'radio__label--prefill';
        if (!_this.getElement())
            return _this;
        _this.ajaxLoader = document.querySelector("[".concat(constants_1.DATA_AJAX_LOADER, "]"));
        _this.filterResponse = document.querySelector("[".concat(constants_1.DATA_FILTER_RESPONSE, "]"));
        _this.formElement = _this.getElement().querySelector('form');
        _this.formUri = _this.formElement.getAttribute(constants_1.DATA_FILTER_URI);
        _this.formInputs = _this.getElement().querySelectorAll("[".concat(constants_1.DATA_FILTER_CHANGE, "]"));
        _this.formInputLabels = _this.getElement().querySelectorAll("[".concat(constants_1.DATA_FILTER_CHANGE_LABEL, "]"));
        _this.formRadio = _this.getElement().querySelectorAll("[".concat(constants_1.DATA_FILTER_CHANGE_RADIO, "]"));
        _this.formRadioLabels = _this.getElement().querySelectorAll("[".concat(constants_1.DATA_FILTER_CHANGE_RADIO_LABEL, "]"));
        _this.filterReset = _this.getElement().querySelector("[".concat(constants_1.DATA_FILTER_RESET, "]"));
        _this.filterCheckboxWrap = _this.getElement().querySelector("[".concat(constants_1.DATA_FILTER_CHECKBOX_WRAP, "]"));
        _this.filterHintWrap = _this.getElement().querySelector("[".concat(constants_1.DATA_FILTER_HINT_WRAP, "]"));
        _this.filterSearchField = _this.getElement().querySelector("[".concat(constants_1.DATA_INPUT_SEARCH_FIELD, "]"));
        _this.initEventListeners();
        return _this;
    }
    Filter.prototype.initEventListeners = function () {
        var _this = this;
        var _a, _b;
        this.formElement.addEventListener('submit', function (e) {
            e.preventDefault();
            _this.submitForm();
        });
        this.filterReset.addEventListener('click', function () {
            _this.resetFilter();
        });
        (_a = this.formInputs) === null || _a === void 0 ? void 0 : _a.forEach(function (element) {
            element.addEventListener('click', function () {
                _this.checkboxChecked(constants_1.DATA_FILTER_URI);
            });
            element.addEventListener('change', function () {
                setTimeout(function () {
                    _this.submitForm();
                }, 100);
            });
        });
        // product-filter functionality can be found in 'ProductFilter.ts'
        (_b = this.formRadio) === null || _b === void 0 ? void 0 : _b.forEach(function (element) {
            element.addEventListener('click', function () {
                _this.radioChecked(constants_1.DATA_FILTER_URI);
            });
        });
    };
    Filter.prototype.resetFilter = function () {
        var _this = this;
        var _a, _b, _c;
        (_a = this.filterCheckboxWrap) === null || _a === void 0 ? void 0 : _a.classList.add(constantsClasses_1.CLASS_HIDDEN);
        (_b = this.filterHintWrap) === null || _b === void 0 ? void 0 : _b.classList.remove(constantsClasses_1.CLASS_HIDDEN);
        if (this.filterSearchField) {
            this.filterSearchField.value = '';
        }
        (_c = this.formInputs) === null || _c === void 0 ? void 0 : _c.forEach(function (element) {
            element.checked = false;
        });
        this.formInputLabels.forEach(function (element) {
            element.classList.add(_this.CLASS_CHECKBOX_PREFILL);
        });
        this.submitForm();
    };
    Filter.prototype.checkboxChecked = function (formName) {
        var _this = this;
        var isAnyBoxChecked = false;
        var checkboxes = this.getElement().querySelectorAll("[".concat(formName, "] input[type=\"checkbox\"]"));
        for (var i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].checked) {
                this.formInputLabels.forEach(function (element) {
                    element.classList.remove(_this.CLASS_CHECKBOX_PREFILL);
                });
                isAnyBoxChecked = true;
                break;
            }
        }
        if (!isAnyBoxChecked) {
            this.formInputLabels.forEach(function (element) {
                element.classList.add(_this.CLASS_CHECKBOX_PREFILL);
            });
        }
    };
    Filter.prototype.radioChecked = function (formName) {
        var _this = this;
        var isAnyRadioChecked = false;
        var radios = this.getElement().querySelectorAll("[".concat(formName, "] input[type=\"radio\"]"));
        for (var i = 0; i < radios.length; i++) {
            if (radios[i].checked) {
                this.formRadioLabels.forEach(function (element) {
                    element.classList.remove(_this.CLASS_RADIO_PREFILL);
                });
                isAnyRadioChecked = true;
                break;
            }
        }
        if (!isAnyRadioChecked) {
            this.formRadioLabels.forEach(function (element) {
                element.classList.add(_this.CLASS_RADIO_PREFILL);
            });
        }
    };
    Filter.prototype.submitForm = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.ajaxLoader.classList.remove(constantsClasses_1.CLASS_HIDDEN);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetch_1.Fetch.fetchPostData(this.formUri, new FormData(this.formElement))];
                    case 2:
                        response = _a.sent();
                        this.filterResponse.innerHTML = response.resultList;
                        history.pushState(null, '', response.url);
                        this.ajaxLoader.classList.add(constantsClasses_1.CLASS_HIDDEN);
                        setTimeout(function () {
                            main_1.accordion.init();
                        }, 200);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.log(e_1);
                        this.ajaxLoader.classList.add(constantsClasses_1.CLASS_HIDDEN);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return Filter;
}(AbstractComponent_1.default));
exports.default = Filter;
